const levelTypes = {
  CentralLevel: 1,
  Center: 2,
  School: 3,
};

export default levelTypes;
